<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Cronograma de Recebimento"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <cronograma-recebimento-form
            operacaoProp="A"
            :cronogramaRecebimento="cronogramaRecebimento"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-recebimento-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import CronogramaRecebimentoForm from './CronogramaRecebimentoForm'

export default {
    components: {
        CronogramaRecebimentoForm
    },

    props: {
        convenio: Object,
        cronogramaRecebimento: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronogramaRecebimento) {
            this.$store.dispatch('addRequest')
            let cronogramaRecebimentoDto = {
                idConvenio : this.$route.params.convenioId,
                dtMesAno: this.$moment('01/'+cronogramaRecebimento.dtMesAno, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                idCronogramaRecebimento: cronogramaRecebimento.idCronogramaRecebimento,
                codSituacao:cronogramaRecebimento.codSituacao,
                dtLiberacao:cronogramaRecebimento.dtLiberacao,
                nuParcela:cronogramaRecebimento.nuParcela,
                nuValorRecebimento:cronogramaRecebimento.nuValorRecebimento,
                percExecucao:cronogramaRecebimento.percExecucao,
                vcDescricao:cronogramaRecebimento.vcDescricao,
                vlLiberado:cronogramaRecebimento.vlLiberado,
            }
            ConveniosServicos.AlterarCronogramaRecebimento(cronogramaRecebimentoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
